<template>
    <EditorPreferencesTabs :features="features" tab-key="appearance">
        <div class="mb-[98px]">
            <EditorLanguage
                v-if="isPersonalTeam"
                :editor-settings="editorSettings"
                :languages="languages"
                @update="updateLanguage"
            />

            <EditorTheme
                v-if="isPersonalTeam"
                :editor-settings="editorSettings"
                @update="updateTheme"
            />

            <CustomColors
                :editor-settings="editorSettings"
                @update-colors="updateColors"
            />
        </div>
    </EditorPreferencesTabs>
</template>
<script lang="ts" setup>
import { route } from 'ziggy-js';
import { PropType } from 'vue';
import languages from '@/data/editor-languages';
import IEditorSettings from '@/types/Settings/IEditorSettings';
import EditorPreferencesTabs from '../components/EditorPreferencesTabs.vue';
import { create } from '@composables/useNotifications';
import { ITopolPageProps } from '@/types/TopolPageProps/TopolPageProps';

defineProps({
    editorSettings: {
        type: Object as PropType<IEditorSettings>,

        default: () => {},
    },
    features: {
        type: Object,
        default: null,
    },
});

const isPersonalTeam = computed(
    () => usePage<ITopolPageProps>().props.team.personal_team
);

const updateLanguage = (language: string) => {
    router.put(
        route('editor-preferences.editor-language.update'),
        {
            language: language,
        },
        {
            preserveScroll: true,
            onSuccess: () => {
                create({
                    title: 'Editor language updated',
                    type: 'success',
                });
            },
            onError: (e) => {
                console.log(e);
                create({
                    title: 'Language not updated',
                    text: 'There was an error updating editor language.',
                    type: 'error',
                });
            },
        }
    );
};

const updateTheme = (theme: string) => {
    router.put(
        route('editor-preferences.editor-theme.update'),
        {
            theme: theme,
        },
        {
            preserveScroll: true,
            onSuccess: () => {
                create({
                    title: 'Editor theme updated',
                    type: 'success',
                });
            },
            onError: () => {
                create({
                    title: 'Theme not updated',
                    text: 'There was an error updating your editor theme.',
                    type: 'error',
                });
            },
        }
    );
};

const updateColors = (colors: Array<string>) => {
    router.put(
        route('editor-preferences.editor-colors.update'),
        {
            colors: colors,
        },
        {
            preserveScroll: true,
            onSuccess: () => {
                create({
                    title: 'Editor custom colors updated',
                    type: 'success',
                });
            },
            onError: () => {
                create({
                    title: 'Colors not updated',
                    text: 'There was an error updating your custom colors.',
                    type: 'error',
                });
            },
        }
    );
};
</script>

<style></style>
